module.exports = __webpack_public_path__ + "static/media/credit-card.71c59881.png";